// 3 short beeps + vibration to signal an interrupted recording.
export function alertInterrupted() {
  navigator.vibrate?.([220, 120, 220, 120, 220]);
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const t0 = ctx.currentTime + 0.05;
    for (let i = 0; i < 3; i++) {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "square";
      osc.frequency.value = 880;
      const t = t0 + i * 0.3;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.25, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.16);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.18);
    }
    setTimeout(() => ctx.close().catch(() => {}), 1300);
  } catch { /* audio unavailable */ }
}

export function requestDoneNotifications() {
  if ("Notification" in window && Notification.permission === "default") Notification.requestPermission().catch(() => {});
}

// Rising two-note chime + browser notification when processing finishes.
export function alertDone(title, body, url) {
  navigator.vibrate?.([120, 80, 120]);
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [660, 990].forEach((f, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      const t = ctx.currentTime + 0.05 + i * 0.22;
      osc.type = "sine";
      osc.frequency.value = f;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.3, t + 0.03);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.4);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.42);
    });
    setTimeout(() => ctx.close().catch(() => {}), 1200);
  } catch { /* audio unavailable */ }
  if (document.hidden && "Notification" in window && Notification.permission === "granted") {
    try {
      const n = new Notification(title, { body, icon: "/icon-192.png", tag: url });
      n.onclick = () => { window.focus(); n.close(); };
    } catch { /* mobile browsers require service worker notifications */ }
  }
}
